import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, User, Phone, CreditCard } from 'lucide-react';
export function PassengerInfoPage() {
  const navigate = useNavigate();
  const [saveInfo, setSaveInfo] = useState(true);
  return <div className="min-h-screen bg-gray-50 pb-24" data-id="element-270">
      <div className="bg-white sticky top-0 z-30 shadow-sm px-4 py-4 flex items-center space-x-3" data-id="element-271">
        <button onClick={() => navigate(-1)} className="p-2 hover:bg-gray-100 rounded-full" data-id="element-272">
          <ArrowLeft size={24} data-id="element-273" />
        </button>
        <h1 className="font-bold font-bengali text-lg" data-id="element-274">যাত্রীর তথ্য</h1>
      </div>

      <div className="p-4 space-y-6" data-id="element-275">
        <div className="bg-white p-5 rounded-2xl shadow-sm border border-gray-200 space-y-4" data-id="element-276">
          <div className="space-y-1" data-id="element-277">
            <label className="text-sm font-medium text-gray-700 font-bengali" data-id="element-278">
              যাত্রীর নাম
            </label>
            <div className="relative" data-id="element-279">
              <User className="absolute left-3 top-3.5 text-gray-400" size={18} data-id="element-280" />
              <input type="text" placeholder="নাম লিখুন" className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none font-bengali" data-id="element-281" />
            </div>
          </div>

          <div className="space-y-1" data-id="element-282">
            <label className="text-sm font-medium text-gray-700 font-bengali" data-id="element-283">
              মোবাইল নম্বর
            </label>
            <div className="relative" data-id="element-284">
              <Phone className="absolute left-3 top-3.5 text-gray-400" size={18} data-id="element-285" />
              <input type="tel" placeholder="017..." className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none font-bengali" data-id="element-286" />
            </div>
          </div>

          <div className="space-y-1" data-id="element-287">
            <label className="text-sm font-medium text-gray-700 font-bengali" data-id="element-288">
              এনআইডি (অপশনাল)
            </label>
            <div className="relative" data-id="element-289">
              <CreditCard className="absolute left-3 top-3.5 text-gray-400" size={18} data-id="element-290" />
              <input type="text" placeholder="জাতীয় পরিচয়পত্র নম্বর" className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none font-bengali" data-id="element-291" />
            </div>
          </div>

          <div className="flex items-center space-x-3 pt-2" data-id="element-292">
            <input type="checkbox" id="save" checked={saveInfo} onChange={e => setSaveInfo(e.target.checked)} className="w-5 h-5 text-blue-600 rounded focus:ring-blue-500" data-id="element-293" />
            <label htmlFor="save" className="text-sm text-gray-600 font-bengali" data-id="element-294">
              পরবর্তী সময়ের জন্য তথ্য সংরক্ষণ করুন
            </label>
          </div>
        </div>

        <button onClick={() => navigate('/payment')} className="w-full bg-blue-700 text-white py-4 rounded-xl font-bold text-xl font-bengali shadow-lg shadow-blue-200" data-id="element-295">
          পেমেন্ট করুন
        </button>
      </div>
    </div>;
}